export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://app.squaay.com';
export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || 'fhmliax4';